angular.module('env.custom',
    [
        'env.customConfig',
        'env.context',
        'env.custom.customBackground',
        'env.custom.customCss',
        'env.custom.customDirective',
        'env.custom.customTemplate',
        'env.custom.customTemplateResolver',
        'env.custom.customResourceResolver',
        'env.custom.customModule' // custom module located in `src/customize/js/customModule.js` folder (it is empty for main branch)
    ])

;